import { render, staticRenderFns } from "./TableFlagItemForm.vue?vue&type=template&id=396db048&"
import script from "./TableFlagItemForm.vue?vue&type=script&lang=js&"
export * from "./TableFlagItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396db048')) {
      api.createRecord('396db048', component.options)
    } else {
      api.reload('396db048', component.options)
    }
    module.hot.accept("./TableFlagItemForm.vue?vue&type=template&id=396db048&", function () {
      api.rerender('396db048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Finance/TableFlagItemForm.vue"
export default component.exports